import { render, staticRenderFns } from "./yatri-campaign.vue?vue&type=template&id=b4352e74"
import script from "./yatri-campaign.vue?vue&type=script&lang=js"
export * from "./yatri-campaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports